// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoContent_video__AIY1v","play":"VideoContent_play__phUNU","preview":"VideoContent_preview__87sJ9"};